import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    name: 'Home',
    path: '/',
    component: () => import('./views/Init.vue')
  },
  {
    name: 'Define',
    path: '/define',
    component: () => import('./views/Define.vue')
  },
  {
    name: 'Forbidden',
    path: '/forbidden',
    component: () => import('./views/Forbidden.vue')
  },
  {
    name: 'User',
    path: '/user',
    component: () => import('./views/LayoutUser.vue'),
    children: [
      {
        name: 'UserBindAccount',
        path: 'bind-account',
        component: () => import(/* webpackChunkName: "user" */'./views/user/BindAccount.vue'),
      },
      {
        name: 'UserPermissionRequest',
        path: 'permission-request',
        component: () => import(/* webpackChunkName: "user" */'./views/user/PermissionRequest.vue'),
      }]
  },
  {
    name: 'Admin',
    path: '/admin',
    component: () => import('./views/LayoutAdmin.vue'),
    children: [
      {
        name: 'AdminBindAccountRequest',
        path: 'bind-account-request',
        component: () => import(/* webpackChunkName: "admin" */'./views/admin/BindAccountRequest.vue'),
      },
      {
        name: 'AdminPermissionRequest',
        path: 'permission-request',
        component: () => import(/* webpackChunkName: "admin" */'./views/admin/PermissionRequest.vue'),
      },
      {
        name: 'AdminAccountList',
        path: 'account-list',
        component: () => import(/* webpackChunkName: "admin" */'./views/admin/AccountList.vue'),
      }]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
